import RouterSection from '@/Layout/components/RouterSection'

export default {
  path: "/guide",
  name: "guide_home",
  component: RouterSection,
  children: [
    {
      path: "/",
      component: () => import("@/views/guide/index.vue"),
    },
    {
      path: "ux",
      component: () => import("@/views/guide/ux.vue"),
    },
    {
      path: "form",
      component: () => import("@/views/guide/form.vue"),
    },
    {
      path: "products",
      component: () => import("@/views/guide/products.vue"),
    },
    {
      path: "dialog",
      component: () => import("@/views/guide/dialog.vue"),
    },
    {
      path: "about",
      component: () => import("@/views/guide/about.vue"),
    },
  ]
};